// generated on build time, from script >> scripts/build-environment-conf.sh

export const environment = {
  production: true,
  env: 'dev',
  baseUrl: 'https://api.dev.opendata.bcds.net',
  cdnImgBaseUrl: 'https://widget.dev.opendata.bcds.net/assets/img/',
  scraperMock: true,
  notificationsBaseUrl: 'wss://notifications.dev.opendata.bcds.net',
  isWebComponent: false // 👇 Variable para el modo SPA o web-component
};


